// src/services/adminService.js
import api from './api';

const updateRetailerLimit = async (retailerId, limit) => {
  const response = await api.put(`/admin/update-retailer-limit/${retailerId}`, { limit });
  return response.data;
};

const getRetailerLimits = async () => {
  const response = await api.get('/admin/retailer-limits');
  return response.data;
};

const adminService = {
  updateRetailerLimit,
  getRetailerLimits
};

export default adminService;